package diana.soleil.design.iraniancanadienbazzar.core.firebase

import org.koin.dsl.module

/**
 * Koin bindings for the Firebase layer. Included by the app composition root (`:shared`). Assumes the
 * Firebase app has already been initialized at the platform entry point (see [FirebaseServices]).
 */
val coreFirebaseModule = module {
    single<FirebaseServices> { DefaultFirebaseServices() }
    single<RemoteConfigService> { DefaultRemoteConfigService(isDebug = get<diana.soleil.design.iraniancanadienbazzar.core.common.AppBuildInfo>().isDebug) }
    single<AuthService> { DefaultAuthService() }
    single<PushMessagingService> { DefaultPushMessagingService() }
}
